// Module
var code = `<div class="mt-1 border-b border-gray-300"> <input class="block w-full border-0 bg-transparent sm:text-sm focus:ring-0" id="pac" type="text" ng-model="\$ctrl.readableLocation" placeholder="{{\$ctrl.placeholder}}"/> </div> `;
// Exports
export default code;